/* advertorial-bundle.js — drives the integrated bundle offer card(s), replicating
   the proven Section Store layout: stacked quantity-break rows; the selected row
   expands to reveal #1/#2/#3 mix-and-match size dropdowns; per-tier + button totals
   update live. Adds all chosen sizes to the basket in one go; Section Store's
   AUTOMATIC quantity discount (2 -> 5%, 3 -> 10%) is applied server-side, so the
   total shown is the total charged. Percentages are mirrored from the app config;
   if those change, update the row data-disc values — the actual charge always
   stays correct because the discount is automatic. Initialises every
   [data-adv-bundle] instance independently. */
(function () {
  function money(cents) { return '£' + (cents / 100).toFixed(2); }

  function initBundle(root, idx) {
    var dataEl = root.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants.length) return;
    var base = variants[0]; // cheapest variant drives the "from" tier prices

    var rows = [].slice.call(root.querySelectorAll('.tsx-adv__ssb-row'));
    var addBtn = root.querySelector('[data-add]');
    if (!rows.length || !addBtn) return;

    function variantById(id) {
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i];
      return null;
    }

    // headline "from" price per row (all-base sizes)
    rows.forEach(function (row, i) {
      var radio = row.querySelector('input[type=radio]');
      radio.name = 'tsx-ssb-' + idx;
      var qty = parseInt(row.getAttribute('data-qty'), 10) || 1;
      var disc = parseFloat(row.getAttribute('data-disc')) || 0;
      var sum = base.price * qty;
      var now = Math.round(sum * (1 - disc / 100));
      row.querySelector('.tsx-adv__ssb-now').textContent = money(now);
      var was = row.querySelector('.tsx-adv__ssb-was');
      if (disc > 0) { was.textContent = money(sum); } else { was.style.display = 'none'; }
      radio.addEventListener('change', function () { if (radio.checked) selectRow(row); });
    });

    function buildSelect(value) {
      var sel = document.createElement('select');
      sel.className = 'tsx-adv__variant tsx-adv__ssb-size';
      sel.setAttribute('aria-label', 'Choose size');
      variants.forEach(function (v) {
        var o = document.createElement('option');
        o.value = v.id; o.textContent = v.title + ' · ' + money(v.price);
        sel.appendChild(o);
      });
      sel.value = value || base.id;
      sel.addEventListener('change', update);
      // keep dropdown interaction from toggling the row's radio
      sel.addEventListener('click', function (e) { e.stopPropagation(); });
      return sel;
    }

    function selectedRow() {
      for (var i = 0; i < rows.length; i++) if (rows[i].querySelector('input[type=radio]').checked) return rows[i];
      return rows[0];
    }

    function selectRow(row) {
      rows.forEach(function (r) {
        r.classList.toggle('is-selected', r === row);
        if (r !== row) r.querySelector('[data-slots]').innerHTML = '';
      });
      var qty = parseInt(row.getAttribute('data-qty'), 10) || 1;
      var slots = row.querySelector('[data-slots]');
      var keep = [].slice.call(slots.querySelectorAll('select')).map(function (s) { return s.value; });
      slots.innerHTML = '';
      if (qty > 1) {
        for (var i = 0; i < qty; i++) {
          var line = document.createElement('span');
          line.className = 'tsx-adv__ssb-slot';
          var tag = document.createElement('span');
          tag.className = 'tsx-adv__ssb-slot-tag';
          tag.textContent = '#' + (i + 1);
          line.appendChild(tag);
          line.appendChild(buildSelect(keep[i]));
          slots.appendChild(line);
        }
      } else {
        // single planter: one size choice, no #n labels
        var only = document.createElement('span');
        only.className = 'tsx-adv__ssb-slot';
        only.appendChild(buildSelect(keep[0]));
        slots.appendChild(only);
      }
      update();
    }

    function update() {
      var row = selectedRow();
      var disc = parseFloat(row.getAttribute('data-disc')) || 0;
      var sum = 0;
      row.querySelectorAll('[data-slots] select').forEach(function (s) {
        var v = variantById(s.value); if (v) sum += v.price;
      });
      var now = Math.round(sum * (1 - disc / 100));
      // reflect the actual selection on the selected row
      row.querySelector('.tsx-adv__ssb-now').textContent = money(now);
      var was = row.querySelector('.tsx-adv__ssb-was');
      if (disc > 0) { was.style.display = ''; was.textContent = money(sum); }
      // and on the button
      if (disc > 0) {
        addBtn.innerHTML = 'Add to basket · <strong>' + money(now) + '</strong> <s>' + money(sum) + '</s>';
      } else {
        addBtn.innerHTML = 'Add to basket · <strong>' + money(now) + '</strong>';
      }
    }

    addBtn.addEventListener('click', function () {
      var row = selectedRow();
      var counts = {};
      row.querySelectorAll('[data-slots] select').forEach(function (s) { counts[s.value] = (counts[s.value] || 0) + 1; });
      var items = Object.keys(counts).map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
      if (!items.length) return;
      var html = addBtn.innerHTML;
      addBtn.disabled = true; addBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items })
      }).then(function (r) { if (!r.ok) throw new Error('add failed'); window.location.href = '/cart'; })
        .catch(function () { addBtn.disabled = false; addBtn.innerHTML = html; alert('Sorry, something went wrong adding to your basket. Please try again.'); });
    });

    selectRow(selectedRow());
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-adv-bundle]');
    for (var i = 0; i < nodes.length; i++) initBundle(nodes[i], i);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
